export const REDUCER_NAME = 'anamnesis'

/* old type form */
export const ALIGNER_TREATMENT_MEDICAL_INFORMATION = 'alignerTreatmentTypeForm.medical'

export const ALIGNER_TREATMENT_EXPECTATION = 'alignerTreatmentTypeForm.expectation'

/* external forms on fire */
export const ALIGNER_TREATMENT = 'alignerTreatment'

export const IMPLANT_TREATMENT = 'implantTreatment'

/* physician assessment */
export const ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT = 'alignerTreatmentPhysicianAssessment'
export const IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT = 'implantTreatmentPhysicianAssessment'

export const IMPLANT_CONSULTATION_AND_FINDINGS = 'implantConsultationAndFindings'

export const IMPLANT_SURGERY_DOCUMENTATION = 'implantSurgeryDocumentation'



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/const.js